module.exports = __webpack_public_path__ + "static/media/brycen9.b2f2f0aa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen9.gif
// module id = 154
// module chunks = 0